export default __webpack_public_path__ + "static/media/separator_text.418c762c.svg";